import { render, staticRenderFns } from "./add-this.vue?vue&type=template&id=6bc518f1&"
import script from "./add-this.vue?vue&type=script&lang=js&"
export * from "./add-this.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports